import { Alert, Icon } from 'antd'
import axios from 'axios'
import NProgress from 'nprogress'
import React from 'react'
import BlockUi from 'react-block-ui'
import ReduxBlockUi from 'react-block-ui/lib/redux'
import 'react-block-ui/style.css'
import { Helmet } from 'react-helmet'
import { withRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { LOCAL_SERVICE_BASE_URL } from '../api/SignerApi'
import '../blockui.scss'
import Loader from '../components/LayoutComponents/Loader'
import MainLayout from './Main'
import styles from './style.module.scss'

class IndexLayout extends React.PureComponent<any, any> {
  previousPath = ''
  state = {
    isServiceDown: false,
  }

  check = () =>
    axios
      .get(`${LOCAL_SERVICE_BASE_URL}/healt/check`)
      .then(response => {
        if (response.data !== true) {
          this.setState({ isServiceDown: true })
        } else {
          this.setState({ isServiceDown: false })
        }
      })
      .catch(error => this.setState({ isServiceDown: true }))

  componentDidUpdate(prevProps) {
    const { location } = this.props
    const { prevLocation } = prevProps
    if (location !== prevLocation) {
      window.scrollTo(0, 0)
    }
  }

  componentDidMount() {
    this.check()

    setInterval(() => {
      this.check()
    }, 2000)
  }

  render() {
    const {
      children,
      location: { pathname, search },
    } = this.props

    // NProgress Management
    const currentPath = pathname + search
    if (currentPath !== this.previousPath) {
      NProgress.start()
    }

    setTimeout(() => {
      NProgress.done()
      this.previousPath = currentPath
    }, 300)

    return (
      <ReduxBlockUi
        tag="div"
        loader={<Loader spinning={true} fullScreen={false} />}
        block={[/PENDING$/i, /REQUEST$/i]}
        unblock={[
          /REJECTED/i,
          /FULFILLED/i,
          /SUCCESS/i,
          '@@common/SAVE_FILE',
          '@@common/SHOW_MODAL',
        ]}
      >
        <BlockUi
          tag="div"
          loader={<Loader spinning={false} fullScreen={false} />}
          blocking={
            this.state.isServiceDown && (pathname === '/info' || pathname == '/create-account')
          }
          message={
            <Alert
              style={{ textAlign: 'left' }}
              className="custom-message"
              message="e-İmza Uygulaması Kapalı"
              description="İşlem boyunca, e-İmza uygulamasının açık olması gerekmektedir. Lütfen e-İmza uygulamasını tekrar çalıştırınız!"
              type="error"
              showIcon
              icon={<Icon style={{ fontSize: 24 }} spin type="loading" />}
            />
          }
        >
          <ToastContainer closeOnClick={false} autoClose={false} />
          <Helmet titleTemplate="NES Bilgi İmza Uygulaması" />
          <MainLayout>
            <div>
              <section
                className={`${styles.login} ${styles.fullscreen}`}
                style={{
                  backgroundImage: `url('resources/images/backgrounds/backgraund.jpg')`,
                }}
              >
                <header className={styles.header}>
                  <a className={styles.logo} href="javascript: void(0);">
                    <img src="resources/images/nes-beyaz-logo.svg" alt="Clean UI Admin Template" />
                  </a>
                </header>
                {children}
              </section>
            </div>
          </MainLayout>
        </BlockUi>
      </ReduxBlockUi>
    )
  }
}

export default withRouter(IndexLayout)
